/**
 * Barcha marshrutlar bir joyda. Sidebar, router va qayta yo'naltirishlar
 * shu obyektdan o'qiydi — manzil o'zgarsa bitta qatordan o'zgaradi.
 */
export const PATHS = {
  DASHBOARD: "/",
  USERS: "/users",
  USER_DETAIL: "/users/:id",
  INVITATIONS: "/invitations",
  INVITATION_DETAIL: "/invitations/:id",
  // Uchta pul ro'yxati bitta bo'lim: manzil menyu tuzilishini
  // takrorlaydi, `/reference/*` bilan bir xil naqshda. Eski
  // manzillar router'da yangisiga yo'naltiriladi.
  FINANCE: "/finance",
  LEDGER: "/finance/ledger",
  PAYMENTS: "/finance/payments",
  WITHDRAWALS: "/finance/withdrawals",
  // Promo kodlar moliya ostida: bonus qahva — bevosita xarajat
  // (mezbon uni chiqarganda platforma pul to'laydi), ya'ni u pul
  // ro'yxatlari bilan bir joyda turishi kerak (ADR 0018).
  PROMO: "/finance/promo",
  // Soliq profillari — moliya ostida: qaror pul harakatiga
  // bevosita ta'sir qiladi (ADR 0019).
  PAYOUTS: "/finance/payouts",
  // Efirlar (ADR 0023) — moliya ostida EMAS: efir marketing quroli
  // va u pul ro'yxatlariga tegmaydi. Takliflar bilan yonma-yon:
  // ikkalasi ham platformadagi uchrashuv, faqat biri ochiq.
  LIVE: "/live",
  LIVE_DETAIL: "/live/:id",
  REPORTS: "/reports",
  // Sharhlar SHIKOYATLAR bilan yonma-yon: ikkalasi ham moderatsiya,
  // va ikkalasi ham bitta savolga javob beradi — "bu odam bilan
  // uchrashish xavfsizmi". Farqi: shikoyat navbat, sharh esa
  // qidiruv — unda «ko'rib chiqilmagan» degan holat yo'q.
  REVIEWS: "/reviews",
  // Xabarlar — moderatsiya blokining oxirida: sharhlar va
  // shikoyatlar "nima bo'ldi" degan savolga javob beradi, bu esa
  // "endi nima deymiz" degan savolga.
  MESSAGES: "/messages",
  REPORT_DETAIL: "/reports/:id",
  // Mezbon bo'lish arizalari — shikoyatlar bilan yonma-yon: ikkalasi
  // ham navbat, ikkalasi ham bitta himoyaning yarmi (biri kirishni
  // qiyinlashtiradi, ikkinchisi o'tib ketganini tutadi).
  HOST_APPLICATIONS: "/host-applications",
  // Ariza ko'rib chiqish — SHEET emas, alohida sahifa. Ariza qarori
  // ikki tomonni yonma-yon talab qiladi: chapda odamning o'zi (profil,
  // ishonch darajasi, tarixi), o'ngda uning yozgani. Yon panelda
  // ikkalasi sig'masdi — moderator u yerda faqat matnni ko'rib,
  // "bu kim?" degan savolga javobsiz qaror qabul qilardi.
  HOST_APPLICATION_DETAIL: "/host-applications/:id",
  ROLES: "/roles",
  // Rol yaratish — alohida sahifa: ruxsatlar ro'yxati o'ttizdan
  // oshdi va u modal oynaga sig'maydi. Yaratish va tahrirlash bitta
  // forma, farqi faqat manzilda.
  ROLE_CREATE: "/roles/new",
  ROLE_DETAIL: "/roles/:id",
  AUDIT: "/audit",
  ANALYTICS: "/analytics",
  REFERENCE: "/reference",
  REFERENCE_INDUSTRIES: "/reference/industries",
  REFERENCE_REGIONS: "/reference/regions",
  REFERENCE_DISTRICTS: "/reference/districts",
  // Sozlamalar ham bo'lim: platforma raqamlari va uchrashuv
  // variantlari bir xil ruxsat ostida, lekin butunlay boshqa ish.
  // `/settings` ning o'zi sahifa emas — birinchi bo'limga yuboradi,
  // ya'ni eski xatcho'plar ishlab turaveradi.
  SETTINGS: "/settings",
  SETTINGS_PLATFORM: "/settings/platform",
  SETTINGS_MEETINGS: "/settings/meetings",
} as const;

/** Xatcho'plar buzilmasin: eski manzil → yangisi. */
export const LEGACY_FINANCE_PATHS = {
  "/ledger": PATHS.LEDGER,
  "/payments": PATHS.PAYMENTS,
  "/withdrawals": PATHS.WITHDRAWALS,
} as const;

export const userDetailPath = (id: string) => `/users/${id}`;
export const broadcastDetailPath = (id: string) => `/live/${id}`;
export const hostApplicationDetailPath = (id: string) => `/host-applications/${id}`;
export const reportDetailPath = (id: string) => `/reports/${id}`;
export const roleDetailPath = (id: string) => `/roles/${id}`;
export const invitationDetailPath = (id: string) => `/invitations/${id}`;
